import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';
import ImgLazyLoad from '~/common/components/image-lazy-loading';

interface Props {
  variantName: string;
  variantImageUrl: string;
  isSelected?: boolean;
  onTabClick: () => void;
  className?: string;
}

export const CompareRangeVariantTabItem = React.memo<Props>(
  ({ variantName, variantImageUrl, className, isSelected, onTabClick }) => (
    <div
      onClick={onTabClick}
      className={cn(className, styles.variantTab, {
        [styles.variantTabSelected]: isSelected,
      })}
    >
      <div className={styles.variantName}>{variantName}</div>
      <ImgLazyLoad
        src={variantImageUrl}
        className={styles.variantImageUrl}
        alt={variantName}
        loading="lazy"
      />
      {isSelected && <div className={styles.ripple} />}
    </div>
  )
);
